module.exports = __webpack_public_path__ + "img/calendar_fill.8ed1c733.svg";